//
// translation.js
//

import * as scroll_anchors from '../../core/js/ScrollAnchors';

const translationSelect = document.querySelector('[data-select-translation]')
const legalContent = document.querySelector('[data-legal-content]')
const legalSections = document.querySelector('[data-legal-sections]')

translationSelect.addEventListener('change', translateChange)

async function translateChange(e) {
  // Fade out section content
  for(let i = 0; i < legalContent.children.length; i++) {
    setTimeout(() => {
      legalContent.children[i].style.transition = 'opacity .6s'
      legalContent.children[i].style.opacity = '0'
    }, i * 200 + 400)
  }

  // Fade out sections
  for(let i = 0; i < legalSections.children.length; i++) {
    setTimeout(() => {
      legalSections.children[i].style.transition = 'opacity .6s'
      legalSections.children[i].style.opacity = '0'
    }, i * 200)
  }
  
  // Fetch page content
  const postId = e.target.options[e.target.selectedIndex].value
  const response = await fetch(`${window.site_url}?page_id=${postId}`)
  const text = await response.text()

  const div = document.createElement('div')
  div.innerHTML = text



  // Get new legal content
  const fetchedLegalContent = div.querySelector('[data-legal-content]')

  legalContent.innerHTML = ''
  for(let i = 0; i < fetchedLegalContent.children.length; i++) {
    fetchedLegalContent.children[i].style.transition = 'opacity .6s'
    fetchedLegalContent.children[i].style.opacity = '0'
    legalContent.appendChild(fetchedLegalContent.children[i].cloneNode(true))
  }

  // Fade in new legal content
  for(let i = 0; i < legalContent.children.length; i++) {
    setTimeout(() => {
      legalContent.children[i].style.transition = 'opacity .6s'
      legalContent.children[i].style.opacity = '1'
    }, i * 200 + 400)
  }



  // Get new legal sections
  const fetchedLegalSections = div.querySelector('[data-legal-sections]')

  legalSections.innerHTML = ''
  for(let i = 0; i < fetchedLegalSections.children.length; i++) {
    fetchedLegalSections.children[i].style.transition = 'opacity .6s'
    fetchedLegalSections.children[i].style.opacity = '0'
    legalSections.appendChild(fetchedLegalSections.children[i].cloneNode(true))
  }

  // Fade in new legal sections
  for(let i = 0; i < legalSections.children.length; i++) {
    setTimeout(() => {
      legalSections.children[i].style.transition = 'opacity .6s'
      legalSections.children[i].style.opacity = '1'
    }, i * 200)
  }


  // Reinitialise smooth scroll for sections
  scroll_anchors.auto_add();

}